import { FC } from 'react';
import { CatButton } from '@blocks-react/components/Button';
import { CatIconWarningTriangle } from '@blocks-react/components/Icons/WarningTriangle';
import { CatInlineNotification } from '@blocks-react/components/InlineNotification';
import { CatHeading } from '@blocks-react/components/Heading';
import { DismissAllBannerProps } from '../types';
import styles from '../NotificationDrawer.module.scss';

export const DismissAllConfirmationBanner: FC<DismissAllBannerProps> = ({
  NOTIFICATIONS_DISMISS_ALL_PAGE,
  CANCEL,
  DISMISS_ALL,
  handleConfirmationBannerCancel,
  handleConfirmationBannerContinue,
}) => {
  return (
    <div className={`d-flex p-3`}>
      <CatInlineNotification
        variant="warning"
        dismissible={false}
        data-testid="dismiss-all-confirmation-banner"
        className={styles['cat-banner']}
      >
        <>
          <CatIconWarningTriangle slot="before" />
          <div className={styles['dismiss-confirmation-popup']}>
            <CatHeading
              variant="label"
              aria-label={NOTIFICATIONS_DISMISS_ALL_PAGE}
            >
              {NOTIFICATIONS_DISMISS_ALL_PAGE}
            </CatHeading>
            <div
              className={`${styles['dismiss-confirmation-popup-btn']} d-flex mt-3 align-items-center`}
            >
              <CatButton
                aria-label={DISMISS_ALL}
                variant="contrast"
                onClick={handleConfirmationBannerContinue}
                data-testid="dismiss-all-continue-button"
              >
                {DISMISS_ALL}
              </CatButton>
              <CatButton
                aria-label={CANCEL}
                variant="ghost"
                onClick={handleConfirmationBannerCancel}
              >
                {CANCEL}
              </CatButton>
            </div>
          </div>
        </>
      </CatInlineNotification>
    </div>
  );
};
